<template>
  <div class="full-height">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm">
          <q-card-section class="q-py-xs" v-if="!insideModal" style="margin-bottom: 70px;">
            <technical-assesment-page-header v-bind="headerDetail" />
            <div class="header-button">
              <q-btn color="primary" icon="mdi-eye" @click="() => showModalAnnexTable = true"
                :disable="annexsReport.length == 0">
                Visualizar Laudo
                ({{ annexsReport.length }})
              </q-btn>
            </div>
            <strong class="commercial-detail"> {{ $gettext('COMMERCIAL').toUpperCase() }}:</strong>
            <hr>
            <div class="commercial-container">
              <div class="row background-detail row-container">
                <div class="col-3 q-px-sm q-mt-md">
                  <strong class="label"><translate>DOCUMENT_CLIENT</translate>:</strong>
                  <span>{{ dataDetail.clientDocument }}</span>
                </div>
                <div class="col-3 q-px-sm q-mt-md">
                  <strong class="label"><translate>CLIENT_GENERATOR</translate>:</strong>
                  <span>{{ dataDetail.clientName }}</span>
                </div>
                <div class="col-4 q-px-sm q-mt-md">
                  <strong class="label"><translate>ADDRESS</translate>:</strong>
                  <span> {{ dataDetail.addres }}</span>
                </div>
                <div class="col-2 q-px-sm q-mt-md">
                  <strong class="label"><translate>ANUAL_QUANTITY</translate>:</strong>
                  <span>{{ formatNumberToDecimal(dataDetail.quantityGeneration) }}</span>
                </div>

              </div>
              <div class="row row-container">
                <div class="col-3 q-px-sm q-mt-md">
                  <strong class="label"><translate>DOCUMENT_GENERATOR</translate>:</strong>
                  <span>{{ dataDetail.generatorDocument }}</span>
                </div>

                <div class="col-3 q-px-sm q-mt-md">
                  <strong class="label"><translate>GENERATOR</translate>:</strong>
                  <span>{{ dataDetail.generatorName }}</span>
                </div>
                <div class="col-4 q-px-sm q-mt-md">
                  <strong class="label"><translate>LINE_OF_ACTIVITY</translate>:</strong>
                  <span>{{ dataDetail.activityArea }}</span>
                </div>
              </div>
              <div class="row background-detail row-container">
                <div class="col-3 q-px-sm q-mt-md">
                  <strong class="label"><translate>LANDFILL_SINGULAR</translate>:</strong>
                  <span>{{ dataDetail.landfillName }}</span>
                </div>

                <div class="col-3 q-px-sm q-mt-md">
                  <strong class="label"><translate>RESIDUE_SINGULAR</translate>:</strong>
                  <span>{{ dataDetail.residue }}</span>
                </div>
                <div class="col-4 q-px-sm q-mt-md">
                  <strong class="label"><translate>GENERATOR_PROCESS</translate>:</strong>
                  <span>{{ dataDetail.generatorProcess }}</span>
                </div>
              </div>
              <div class="row row-container">
                <div class="col-3 q-px-sm q-mt-md">
                  <strong class="label"><translate>CADRI</translate>:</strong>
                  <span>{{ dataDetail.cadriNumber }}</span>
                </div>

                <div class="col-3 q-px-sm q-mt-md">
                  <strong class="label"><translate>USER</translate>:</strong>
                  <span>{{ dataDetail.userCommercial }}</span>
                </div>
                <div class="col-6 q-px-sm q-mt-md">
                  <strong class="label"><translate>OBSERVATION</translate>:</strong>
                  <span>{{ dataDetail.commercialObservation }}</span>
                </div>
              </div>
            </div>
            <div v-if="hasLaboratoryData">
              <div class="departament-division">
                <strong><translate>LABORATORY</translate></strong>
                <hr>
              </div>
              <div class="laboratory-container">
                <div class="row background-detail row-container">
                  <div class="col-3 q-px-sm q-mt-md">
                    <strong class="label"><translate>PH</translate>:</strong>
                    <span>{{ dataDetail.ph }}</span>
                  </div>

                  <div class="col-3 q-px-sm q-mt-md">
                    <strong class="label"><translate>WATER_REATIVITY</translate>:</strong>
                    <span>{{ getStringValueAusentOrPresentByBooleanValue(dataDetail.waterReactivity) }}</span>
                  </div>

                  <div class="col-3 q-px-sm q-mt-md">
                    <strong class="label"><translate>FREE_LIQUIDS</translate>:</strong>
                    <span>{{ getStringValueAusentOrPresentByBooleanValue(dataDetail.freeLiquids) }}</span>
                  </div>
                </div>
                <div class="row row-container">
                  <div class="col-3 q-px-sm q-mt-md">
                    <strong class="label"><translate>TEMPERATURE</translate>:</strong>
                    <span>{{ formatNumberToDecimal(dataDetail.temperature) }}° </span>
                  </div>

                  <div class="col-3 q-px-sm q-mt-md">
                    <strong class="label"><translate>ACID_REATIVITY</translate>:</strong>
                    <span>{{ getStringValueAusentOrPresentByBooleanValue(dataDetail.acidReativity) }}</span>
                  </div>

                  <div class="col-3 q-px-sm q-mt-md"> <strong class="label"><translate>FREE_LIQUIDS_VALUE</translate>:</strong>
                    <span v-if="dataDetail.freeLiquidsQtd">{{ formatNumberToDecimal(dataDetail.freeLiquidsQtd) }} %</span>
                  </div>
                </div>
                <div class="row background-detail row-container">
                  <div class="col-3 q-px-sm q-mt-md">
                    <strong class="label"><translate>RADIOACTIVITY</translate>:</strong>
                    <span>{{ formatNumberToDecimal(dataDetail.radioactivity) }}</span>
                  </div>

                  <div class="col-3 q-px-sm q-mt-md">
                    <strong class="label"><translate>BASE_REATIVITY</translate>:</strong>
                    <span>{{ getStringValueAusentOrPresentByBooleanValue(dataDetail.reativityBase) }}</span>
                  </div>

                  <div class="col-3 q-px-sm q-mt-md"> <strong class="label"><translate>OILS_GREASES</translate>:</strong>
                    <span>{{ getStringValueAusentOrPresentByBooleanValue(dataDetail.oilsGreases) }} <span
                        v-if="dataDetail.oilsGreasesQtd">-</span> {{ formatNumberToDecimal(dataDetail.oilsGreasesQtd)
                      }} %</span>
                  </div>
                </div>
              </div>

              <div class="departament-division">
                <strong><translate>VISUAL</translate></strong>
                <hr>
              </div>
              <div class="visual-container">
                <div class="row background-detail row-container">
                  <div class="col-3 q-px-sm q-mt-md">
                    <strong class="label"><translate>COLOR</translate></strong>
                    <span>{{ dataDetail.color }}</span>
                  </div>

                  <div class="col-3 q-px-sm q-mt-md">
                    <strong class="label"><translate>SMELL</translate></strong>
                    <span>{{ getStringValueAusentOrPresentByBooleanValue(dataDetail.smell) }}</span>
                  </div>
                  <div class="col-4 q-px-sm q-mt-md">
                    <strong class="label"><translate>ASPECTY</translate>:</strong>
                    <span> {{ dataDetail.aspect }}</span>
                  </div>
                </div>
              </div>

              <div class="departament-division">
                <strong><translate>ADITIONAL_INFOMATIONS</translate></strong>
                <hr>
              </div>
              <div class="info-container">
                <div class="row background-detail row-container">
                  <div class="col-4 q-px-sm q-mt-md">
                    <strong class="label"><translate>USER</translate>:</strong>
                    <span>{{ dataDetail.userLaboratory }}</span>
                  </div>

                  <div class="col-8 q-px-sm q-mt-md">
                    <strong class="label"><translate>OBSERVATION</translate>:</strong>
                    <span>{{ dataDetail.laboratoryObservation }}</span>
                  </div>
                </div>
              </div>
            </div>

          </q-card-section>

          <footer class="q-py-md">
            <strong style="margin-right: 10px"><translate>REFERENCE_PROCCESS</translate>:</strong> {{
              dataDetail.landfillLaboratoryProcedure }}
          </footer>
        </q-card>
      </div>
    </div>
    <annex-report-table :show="showModalAnnexTable" @input="(open) => (showModalAnnexTable = open)"
      :rows="annexsReport"/>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
const { pageDetail } = JtCrud
import TechnicalAssesmentPageHeader from './TechnicalAssesmentPageHeader.vue'
import techinicalAssementRepository from './TechinicalAssementRepository.js'
import AnnexReportTable from './AnnexReportTable.vue'

@Component({
  name: 'pageDetail',
  mixins: [pageDetail],
  components: { TechnicalAssesmentPageHeader, AnnexReportTable },
  provide () {
    return {
      jtdynamicform: this
    }
  },
  props: {
    name: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object,
    buttonHidden: {
      type: Boolean,
      default: false
    }
  }
})
class PageDetail extends Vue {
  dataDetail = {}
  headerDetail = {}
  annexsReport = []
  hasLaboratoryData = false

  showModalAnnexTable = false

  getStringValueAusentOrPresentByBooleanValue (booleanValue) {
    return booleanValue ? this.$gettext('PRESENT') : this.$gettext('ABSENT')
  }

  formatNumberToDecimal (number) {
    if (number) { return Number.parseFloat(number).toFixed(2) }
  }

  async mounted () {
    this.hasLaboratoryData = !!this.params.idLaboratory
    const { data } = await techinicalAssementRepository.getPageDetailData(this.params.id)
    this.dataDetail = data
    this.headerDetail.procedureRevision = data.procedureRevision
    this.headerDetail.processNumber = data.process + '/ ' + data.year
    this.headerDetail.technicalRevision = data.assementRevision
    this.headerDetail.createdAt = data.createdDate
    this.headerDetail.code = data.landfillLaboratoryProcedureCode
    this.annexsReport = [...data.annexReport]
  }
}
export default PageDetail
</script>
<style lang="stylus" scoped>

.commercial-detail {
    position: absolute;
    left:18px;
    top: 130px
}

.departament-division {
  margin-top: 28px;
}

hr {
    background-color: rgba(128, 128, 128, 0.1);
    border-color: rgba(128, 128, 128, 0.1);
}
.background-detail {
  background-color: #F2F4F5;
}

.row-container div {
  margin-top: 4px;
}

.row-container {
  margin-top: 14px;
}

.label {
  margin-right: 4px;
  display: inline-block;
}

.header-button {
  display: flex;
  justify-content: flex-end;
}

.header-info {
  padding-top: 10px;
}

footer {
  display: flex;
  justify-content: center;
  margin-top: 0px;
  background-color: #d7dde0;
}

.grid-layout {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-auto-rows: max-content;
}
</style>
